import { EventEmitter } from 'events';

import { StateJSON } from '@spazious/dollhouse-store';

export enum DollhouseMessage {
  RestrictedAreaEntered,
  ConfirmInvisibleNodesReset,
  GetDeletionsCount,
  ConfirmCameraPathReset,
}

export enum MainViewMessage {
  RestrictedAreaActionRevert,
  RestrictedAreaActionIgnore,
  InvisibleNodesResetConfirm,
  MetadataResetCancel,
  CameraPathResetConfirm,
  CameraPathResetCancel,
}

export type EventManagerEvents = {
  save: [any];
  change: [StateJSON];
  error: [string];
  notification: [string];
  dollhouseMessage: [DollhouseMessage, (string | number)?];
  mainViewMessage: [MainViewMessage];
  saveScreenshot: [any];
};

export interface EventManagerSubscribeCallback {
  (eventName: string, args: any[]): void;
}

export interface EventManager extends EventEmitter<EventManagerEvents> {
  subscribe(cb: EventManagerSubscribeCallback): () => void;
}

export const EVENT_MANAGER_EVENTS = [
  'save',
  'error',
  'change',
  'notification',
  'dollhouseMessage',
  'mainViewMessage',
  'saveScreenshot',
] as (keyof EventManagerEvents)[];

export class EventManagerImpl extends EventEmitter<EventManagerEvents> implements EventManager {
  subscribe(cb: EventManagerSubscribeCallback) {
    const unsubscribeFns = EVENT_MANAGER_EVENTS.map((eventName) => {
      const listener = (...args: any[]) => {
        cb(eventName, args);
      };

      this.on(eventName, listener);

      return () => {
        this.off(eventName, listener);
      };
    });

    return () => {
      unsubscribeFns.forEach((fn) => fn());
    };
  }
}

export const createEvents = () => new EventManagerImpl();
